module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Zeglingen-cf607036758c17a2fa068f1029beb422.svg";